import Stars from "src/components/stars/Stars";
import Image from "next/image";
import { Review, ReviewerType } from "src/config/reviewsPerProduct";
import formatDate from "src/helpers/formatDate";
import isArabic from "src/helpers/isArabic";
import { useEffect } from "react";
import Aos from "aos";

interface SingleReviewCardProps {
  review: Review;
}

const SingleReviewCard = ({ review }: SingleReviewCardProps) => {
  useEffect(() => {
    Aos.init({
      easing: "ease-in",
      once: true,
      disable: "mobile",
    });
  });

  return (
    <li
      className={`cols-span-1 mb-4 flex break-inside-avoid flex-col gap-4 border border-gray-300 ${
        review.type === ReviewerType.INFLUENCER ? "bg-beige-400" : ""
      } p-8`}
      data-aos="fade-up"
    >
      <div>
        <Stars rating={5} starClassName="w-4" />
      </div>
      <p className={isArabic(review.text) ? "text-right" : "text-left"}>
        {review.text}
      </p>
      <div className="">
        {review.type === ReviewerType.INFLUENCER &&
          review.influencer &&
          review.influencer.photo && (
            <div className="pb-1">
              <a
                rel="noreferrer"
                target="_blank"
                href={`https://www.instagram.com/${review.influencer.ig_handle.replace(
                  "@",
                  ""
                )}`}
              >
                <Image
                  src={review.influencer.photo}
                  alt="Influencer image"
                  className="my-auto flex h-10 w-10 rounded-full border-2 border-white"
                  sizes="5rem"
                  width={0}
                  height={0}
                />
              </a>
            </div>
          )}
        <div className="mt-auto flex items-end justify-between border-t border-gray-600">
          <p className="font-semibold">
            {review.name}{" "}
            {review.type === ReviewerType.INFLUENCER && review.influencer && (
              <a
                rel="noreferrer"
                target="_blank"
                href={`https://www.instagram.com/${review.influencer.ig_handle.replace(
                  "@",
                  ""
                )}`}
                className="text-xs font-normal"
              >
                {review.influencer.ig_handle}
              </a>
            )}
          </p>
          <p className="text-xs">{formatDate(review.date)}</p>
        </div>
      </div>
    </li>
  );
};

export default SingleReviewCard;
